import { render, staticRenderFns } from "./ArticlesList.vue?vue&type=template&id=0ee59968&scoped=true"
import script from "./ArticlesList.vue?vue&type=script&lang=js"
export * from "./ArticlesList.vue?vue&type=script&lang=js"
import style0 from "./ArticlesList.vue?vue&type=style&index=0&id=0ee59968&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee59968",
  null
  
)

export default component.exports